import { FeatureType, FilterModel, FilterProfiles, SourceTypeDetails } from "../generated";

export interface SharedState {
  filterProfilesAsJson: string | null;
  filterProfiles: FilterProfiles[];
  filterModel: FilterModel;
  profileCreated: boolean;
  filterId?: number;
  sourceTypes: SourceTypeDetails[] | null;
  featureTypes?: FeatureType[];
}

export const initialState: SharedState = {
  filterProfilesAsJson: null,
  filterProfiles: [],
  filterModel: {},
  profileCreated: false,
  sourceTypes: null,
  featureTypes: undefined
}
